import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { Grid, Button, Snackbar } from "@material-ui/core";
import Select from "react-select";
import MuiAlert from "@material-ui/lab/Alert";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import {
  getEvent,
  editEvent,
  getEventCategories,
  getLocations,
  getMembers
} from "../../logic/APIHandler";
import { filterData } from "../../logic/Handler";
import Sidebar from "../../components/Sidebar_Com";
import Spinner from "../../components/Loading_Com";
import StatusModal from "../../components/Modal_Com";
import cities from "../../assets/data/Cities";
import "../../styles/Form_Style.css";
import {
  TextInput,
  DateInput,
  TimeInput,
  ImageInput,
  URLInput,
  GroupedDropdown,
  DropdownInput,
  PhoneOnChangeInput
} from "../../logic/FormInput";
import moment from "moment";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function DetailNextEvent(props) {
  const history = useHistory();
  const { register, handleSubmit, errors, control, setValue } = useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [openJWT, setOpenJWT] = useState(false);
  const [edit, setEdit] = useState("Edit Acara");
  const [pageTitle, setPageTitle] = useState("Detail Acara");
  const [hide, setHide] = useState("hide");
  const [nonHide, setNonHide] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  const [idEvent, setIDEvent] = useState(null);
  const [cityData, setCityData] = useState([]);
  const [locationNames, setLocationNames] = useState([]);
  const [categories, setCategories] = useState([]);
  const [currCateg, setCurrCateg] = useState(null);
  const [memberData, setMemberData] = useState([]);
  const [picContact, setPICContact] = useState("");
  const [selectedPIC, setSelectedPIC] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState("slide-out");
  const windowWidth = window.innerWidth;
  const [state, setState] = useState({
    selectedDate: moment(),
    selectedTime: moment(),
    banner: "",
    thumbnail: "",
    data: []
  });

  // Method that run first when the page is opened
  useEffect(() => {
    const idEvent = props.match.params.id;
    setIDEvent(idEvent);
    let res = [];
    cities.forEach((val) => {
      res.push({ value: val, label: val });
    });
    setCityData(res);
    if (idEvent) {
      getData(idEvent);
      getAllLocations();
    } else {
      console.log("ID not found");
    }
  }, [props.match.params.id]);

  // Handle toggle edit event button
  const onClickEditEvent = () => {
    if (edit === "Edit Acara") {
      setEdit("Cancel");
      setPageTitle("Edit Acara");
      setHide("");
      setNonHide("hide");
      setIsDisabled(false);
    } else {
      history.go(0);
    }
  };

  // Get all members
  const getMember = async () => {
    let resp = await getMembers();
    if (resp[0] && resp[0].status === 200) {
      let members = await filterData(resp[0].data, "status", "active");
      let res = [];
      members.forEach((member) => {
        res.push({
          value: member.phone_number,
          label: member.name
        });
      });
      setMemberData(res);
      setIsLoading(false);
    } else if (resp[1] && resp[1].status === 401) {
      setIsLoading(false);
      setOpenJWT(true);
    } else {
      console.log(resp);
      if (resp[1].data && resp[1].data[0].msg) {
        setErrorText(resp[1].data[0].msg);
      } else {
        setErrorText(resp[1].message);
      }
      setOpenErrorAlert(true);
      setIsLoading(false);
    }
  };

  // Get event's data from API
  const getData = async (id) => {
    setIsLoading(true);
    let resp = await getEvent(id);
    if (resp[0] && resp[0].status === 200) {
      const event = resp[0].data;
      setValue("name", event.name);
      setValue("description", event.description);
      setValue("pic", { label: event.pic, value: event.pic_contact });
      setSelectedPIC(
        event.pic ? { label: event.pic, value: event.pic_contact } : null
      );
      setValue("pic_contact", event.pic_contact);
      setPICContact(event.pic_contact);
      let eventDate = event.date.substring(0, 10);
      setValue("date", eventDate);
      let formatedDate = event.date.substring(0, 19);
      setValue("address", event.address);
      setValue("address_link", event.address_link);
      setValue("video_url", event.video_url);
      const defaultCategory = {
        id: event.event_categories._id,
        value: event.event_categories.name,
        label: event.event_categories.name
      };
      setValue("event_category", defaultCategory);
      if (event.city) {
        setSelectedCity({
          label: event.city,
          value: event.city
        });
        setValue("city", {
          label: event.city.charAt(0).toUpperCase() + event.city.slice(1),
          value: event.city
        });
      }
      if (event.location_id) {
        setValue("location", event.location_id);
        setCurrCateg(event.location_id);
      }

      let categories = await getEventCategories();
      const filteredCategories = await filterData(
        categories[0].data,
        "isDeleted",
        false
      );
      let res = [];
      filteredCategories.forEach((category) => {
        res.push({
          id: category._id,
          label: category.name,
          value: category.name
        });
      });
      setState({
        ...state,
        selectedDate: formatedDate,
        selectedTime: moment(event.date),
        banner: event.banner !== "undefined" ? event.banner : "",
        thumbnail: event.thumbnail !== "undefined" ? event.thumbnail : "",
        data: res
      });

      getMember();
    } else if (resp[1] && resp[1].status === 401) {
      setIsLoading(false);
      setOpenJWT(true);
    } else {
      console.log(resp);
      if (resp[1].data && resp[1].data[0].msg) {
        setErrorText(resp[1].data[0].msg);
      } else {
        setErrorText(resp[1].message);
      }
      setOpenErrorAlert(true);
      setIsLoading(false);
    }
  };
  // Get all locations
  const getAllLocations = async () => {
    setIsLoading(true);
    let resp = await getLocations();
    if (resp[0] && resp[0].status === 200) {
      let result = resp[0].data;
      let categs = [],
        names = [];
      result.forEach((res) => {
        if (
          categs.filter((temp) => temp.category === res.category).length < 1
        ) {
          categs.push(res);
        }
        if (res.category !== "Pusat" && res.category !== "Luar Wilayah") {
          names.push(res);
        }
      });
      setCategories(categs);
      setLocationNames(names);
      setIsLoading(false);
    } else if (resp[0] && resp[0].status === 204) {
      setErrorText(resp[0].message);
      setOpenErrorAlert(true);
      setIsLoading(false);
    } else if (resp[1] && resp[1].status === 401) {
      setIsLoading(false);
      setOpenJWT(true);
    } else {
      console.log(resp);
      if (resp[1].data && resp[1].data[0].msg) {
        setErrorText(resp[1].data[0].msg);
      } else {
        setErrorText(resp[1].message);
      }
      setOpenErrorAlert(true);
      setIsLoading(false);
    }
  };

  // Handle input time onchange
  const handleTimeChange = (time) => {
    setState({
      ...state,
      selectedTime: time
    });
  };
  // Handle input date onchange
  const handleDateChange = (date) => {
    setState({
      ...state,
      selectedDate: moment(date)
    });
  };

  // Make the website stay still for __ ms
  const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };
  // Close toast
  const handleCloseAlert = () => {
    setOpenSuccessAlert(false);
    setOpenErrorAlert(false);
  };

  // Toggle sidebar menu in responsive
  const toggleSidebar = () => {
    if (isSidebarOpen === "slide-out") {
      setIsSidebarOpen("slide-in");
    } else {
      setIsSidebarOpen("slide-out");
    }
  };

  // Send updated data event to server
  const onSubmit = async (data) => {
    setIsLoading(true);
    if (
      currCateg.category === "Pusat" ||
      currCateg.category === "Luar Wilayah"
    ) {
      data["chapter"] = currCateg._id;
    } else {
      data["chapter"] = data.location._id;
    }
    // data.date = moment(
    //   data.date + " " + data.time,
    //   "DD/MM/YYYY HH:mm"
    // ).toISOString();

    let resp = await editEvent(idEvent, data, selectedCity.value);
    if (resp[0] && resp[0].status === 200) {
      setOpenSuccessAlert(true);
      await sleep(1000);
      history.go(0);
    } else {
      console.log(resp);
      if (resp[1].data && resp[1].data[0].msg) {
        setErrorText(resp[1].data[0].msg);
      } else {
        setErrorText(resp[1].message);
      }
      setOpenErrorAlert(true);
    }
    setIsLoading(false);
  };

  return (
    <div id="detail-prev-event" className="content">
      {isLoading ? <Spinner /> : ""}
      <Sidebar sidebarState={windowWidth < 768 ? isSidebarOpen : ""} />

      <StatusModal
        open={openJWT}
        modalType="handle-jwt"
        modalTitle="Token Anda Sudah Expire"
      />

      <Grid container className="responsive-header">
        <Grid item xs={6}>
          <h2>IDEPRENEURS</h2>
        </Grid>
        <Grid item xs={6} className="menu-icon-btn">
          <Button variant="outlined" onClick={toggleSidebar}>
            {isSidebarOpen === "slide-out" ? <MenuIcon /> : <CloseIcon />}
          </Button>
        </Grid>
      </Grid>

      <Grid container className="grid-container">
        <Snackbar
          open={openSuccessAlert}
          autoHideDuration={2500}
          onClose={handleCloseAlert}
        >
          <Alert severity="success">Berhasil Update Acara</Alert>
        </Snackbar>
        <Snackbar
          open={openErrorAlert}
          autoHideDuration={2000}
          onClose={handleCloseAlert}
        >
          <Alert severity="error">{errorText}</Alert>
        </Snackbar>
        <Grid item xs={12}>
          <form onSubmit={handleSubmit(onSubmit)} className="add-form">
            <Grid container>
              <Grid item xs={12}>
                <h1 style={{ marginBottom: "2rem" }}>{pageTitle}</h1>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12} md={6}>
                {/* Input for category name */}
                <TextInput
                  label="Nama"
                  name="name"
                  placeholder="Nama"
                  className="form-left-field"
                  validation={register({ required: "*nama harus diisi" })}
                  errors={errors.name}
                  errorClassName="text-required-half"
                  disabled={isDisabled}
                />
              </Grid>
              <Grid item xs={12} md={6} style={{ position: "relative" }}>
                {/* Input for event category */}
                <GroupedDropdown
                  label="Kategori Acara"
                  labelPosition="half-right-label"
                  name="event_category"
                  className={`
                                        form-right-field grouped-field 
                                        ${isDisabled ? "disabled-field" : ""}
                                    `}
                  control={control}
                  options={state.data}
                  defaultValue=""
                  errors={errors.event_category}
                  errorClassName="text-required-half half-right"
                  disabled={isDisabled}
                />
              </Grid>
            </Grid>

            {/* Input for description */}
            <TextInput
              label="Deskripsi"
              name="description"
              placeholder="Deskripsi"
              className="full-width add-margin-bottom"
              validation={register({ required: "*deskripsi harus diisi" })}
              errors={errors.description}
              errorClassName="text-required"
              disabled={isDisabled}
              multiline={true}
              rows={3}
            />

            <Grid container>
              <Grid item xs={12} md={6}>
                {/* Input for PIC */}
                <DropdownInput
                  label="PIC"
                  name="pic"
                  className="form-left-field add-margin-bottom tf-label"
                  keepData={(data) => {
                    setSelectedPIC(data);
                    if (data) setPICContact(data.value);
                    else setPICContact("");
                  }}
                  disableClearable={false}
                  control={control}
                  options={memberData}
                  getOptionLabel={(option) => option.label}
                  value={selectedPIC}
                  required={false}
                  disabled={isDisabled}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                {/* Input for PIC contact number */}
                <PhoneOnChangeInput
                  label="Nomor Kontak PIC"
                  name="pic_contact"
                  placeholder="Nomor Kontak PIC"
                  className="form-right-field"
                  value={picContact}
                  onChange={(val) => setPICContact(val)}
                  validation={register}
                  disabled={isDisabled}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12} md={6}>
                {/* Input for event date */}
                <DateInput
                  label="Tanggal Acara"
                  name="date"
                  value={state.selectedDate}
                  onChange={handleDateChange}
                  className="form-left-field"
                  validation={register}
                  errors={errors.date}
                  errorClassName="text-required-half"
                  // disablePast={true}
                  disabled={isDisabled}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                {/* Input for event time */}
                <TimeInput
                  label="Waktu Acara"
                  name="time"
                  value={state.selectedTime}
                  onChange={handleTimeChange}
                  className="form-right-field"
                  validation={register}
                  errors={errors.time}
                  errorClassName="text-required-half"
                  disabled={isDisabled}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12} md={6}>
                {/* Input for address */}
                <TextInput
                  label="Lokasi Acara"
                  name="address"
                  placeholder="Lokasi Acara"
                  className="form-left-field"
                  validation={register}
                  errors={errors.address}
                  errorClassName="text-required-half"
                  disabled={isDisabled}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                {/* Input for address link */}
                <URLInput
                  label="Link Lokasi"
                  name="address_link"
                  placeholder="Link Lokasi"
                  className="form-right-field"
                  validation={register}
                  errors={errors.address_link}
                  errorClassName="text-required-half"
                  disabled={isDisabled}
                />
              </Grid>
              <Grid
                item
                xs={12}
                className="grouped-layout"
                style={{ position: "relative" }}
              >
                <label className="grouped-label">Kota Tempat Acara *</label>
                <Select
                  value={selectedCity}
                  onChange={(val) => setSelectedCity(val)}
                  options={cityData}
                  className={`full-width add-margin-bottom grouped-field
                                        ${isDisabled ? "disabled-field" : ""}`}
                  isClearable={false}
                />
              </Grid>
              <Grid
                item
                xs={12}
                style={{
                  display:
                    selectedCity && selectedCity.value == "Lainnya"
                      ? "block"
                      : "none"
                }}
              >
                {/* Free text input for domicile */}
                <TextInput
                  label="Nama Kota *"
                  name="city"
                  placeholder="Nama Kota"
                  className="full-width add-margin-bottom"
                  validation={register({
                    required:
                      selectedCity && selectedCity.value == "Lainnya"
                        ? "*nama kota harus diisi"
                        : false
                  })}
                  errors={errors.city}
                  errorClassName="text-required"
                />
              </Grid>
              <Grid item xs={12} style={{ position: "relative" }}>
                <DropdownInput
                  label="Kategori Wilayah"
                  name="categories"
                  className="full-width add-margin-bottom tf-label"
                  keepData={(data) => {
                    setValue("location", null);
                    setCurrCateg(data);
                  }}
                  disableClearable={true}
                  control={control}
                  options={categories}
                  getOptionLabel={(option) => option.category}
                  value={currCateg}
                  required={true}
                  disabled={isDisabled}
                />
              </Grid>
              <Grid item xs={12} style={{ position: "relative" }}>
                <GroupedDropdown
                  label="Nama Wilayah *"
                  labelPosition={
                    currCateg &&
                    currCateg.category !== "Pusat" &&
                    currCateg.category !== "Luar Wilayah"
                      ? ""
                      : "hide-label"
                  }
                  name="location"
                  className={`full-width add-margin-bottom grouped-field
                                        ${isDisabled ? "disabled-field" : ""}
                                        ${
                                          currCateg &&
                                          currCateg.category !== "Pusat" &&
                                          currCateg.category !== "Luar Wilayah"
                                            ? ""
                                            : "hide"
                                        }
                                    `}
                  rules={{ required: "*nama wilayah harus dipilih" }}
                  control={control}
                  options={
                    !currCateg
                      ? null
                      : locationNames.filter(
                          (res) => res.category === currCateg.category
                        )
                  }
                  getOptionLabel={(option) => option.name}
                  isClearable={false}
                  defaultValue=""
                  errors={errors.location}
                  errorClassName="text-required"
                />
              </Grid>
            </Grid>

            {/* Input for video URL */}
            <URLInput
              label="URL Video"
              name="video_url"
              placeholder="URL Video"
              className="full-width add-margin-bottom"
              validation={register}
              errors={errors.video_url}
              errorClassName="text-required"
              disabled={isDisabled}
            />

            <Grid
              container
              className={`
                            gallery-section add-margin-bottom
                            ${isDisabled ? "disabled-border" : ""}
                        `}
            >
              <Grid item xs={12}>
                <h2>Banner & Thumbnail</h2>
              </Grid>
              <Grid item xs={12} md={6} style={{ marginBottom: "15px" }}>
                {/* Input for banner image */}
                <ImageInput
                  name="banner"
                  label="Banner"
                  ratioLabel="Ratio 8:3"
                  validation={register}
                  errors={errors.banner}
                  isEdit={true}
                  control={control}
                  defaultImg={state.banner}
                  canDelete={false}
                  disabled={isDisabled}
                  overallClassName="half-input-image eight-three-size"
                />
              </Grid>
              <Grid item xs={12} md={6} style={{ marginBottom: "15px" }}>
                {/* Input for thumbnail image */}
                <ImageInput
                  name="thumbnail"
                  label="Thumbnail"
                  ratioLabel="Ratio 3:2"
                  validation={register}
                  errors={errors.thumbnail}
                  isEdit={true}
                  control={control}
                  defaultImg={state.thumbnail}
                  disabled={isDisabled}
                  overallClassName="half-input-image three-two-size"
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  className={`edit-btn ${nonHide}`}
                  onClick={onClickEditEvent}
                >
                  {edit}
                </Button>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  onClick={onClickEditEvent}
                  className={`add-cancel-btn ${hide}`}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  style={{ float: "right", marginRight: "15px" }}
                  className={`add-new-btn responsive-submit-btn ${hide}`}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </div>
  );
}
